import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared axios instance — sends cookies for auth
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export const resolveMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

// --- Campaigns ---
export const fetchCampaigns = async (params = {}) => (await api.get("/campaigns", { params })).data;
export const fetchCampaign = async (id) => (await api.get(`/campaigns/${id}`)).data;
export const fetchMyCampaigns = async () => (await api.get("/campaigns/mine")).data;
export const createCampaign = async (payload) => (await api.post("/campaigns", payload)).data;

// --- Pledges ---
export const createPledge = async (campaignId, { reward_id, amount }) =>
  (await api.post(`/campaigns/${campaignId}/pledge`, { reward_id, amount })).data;
export const fetchMyPledges = async () => (await api.get("/pledges/me")).data;

// --- Users ---
export const fetchUser = async (userId) => (await api.get(`/users/${userId}`)).data;
export const fetchUserCampaigns = async (userId) => (await api.get(`/users/${userId}/campaigns`)).data;

// --- Support tickets ---
export const createTicket = async (payload) => (await api.post("/support/tickets", payload)).data;
export const fetchMyTickets = async () => (await api.get("/support/tickets/me")).data;
export const replyToTicket = async (id, message) => (await api.post(`/support/tickets/${id}/reply`, { message })).data;

// --- Public settings ---
export const fetchPublicSettings = async () => (await api.get("/settings/public")).data;

// --- Early Access ---
export const registerEarlyAccess = async (payload) => (await api.post("/early-access", payload)).data;
export const fetchEarlyAccessStats = async () => (await api.get("/early-access/stats")).data;

// --- Admin: Early Access ---
export const adminListEarlyAccess = async (params = {}) => (await api.get("/admin/early-access", { params })).data;

// --- Uploads ---
export const uploadAvatar = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await api.post("/upload/avatar", fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
};

export const uploadMedia = async (file, kind = "cover", onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await api.post(`/upload/media?kind=${kind}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) onProgress(Math.round((evt.loaded / evt.total) * 100));
    },
  })).data;
};
